module.exports = __webpack_public_path__ + "static/media/ZSCE_MF_CIDADES.adf64ef0.pdf";